import { Button, Tabs, Form, Typography, Row, Col } from "antd";

import React, { createRef, useEffect, useState } from "react";
import "../../styles/components.scss";
import { HeaderUser } from "../../components/HeaderUser";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { getListTemplatesUser, toGetDetailAssessment } from "../../utils/APIs";
import { useIndexedDBStore } from "use-indexeddb";
import ScreenLoader from "../../components/ScreenLoader";
import PracticeForm from "../../components/PracticeForm";

const { TabPane } = Tabs;

const NewTool = ({ SettingStore }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [id, setId] = useState(null != location.state ? location.state.id : -1);

  const [elRefs, setElRefs] = React.useState([]);

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(true);
  const [activeKey, setActive] = useState(0);
  const [targetKey, setTargetKey] = useState(-1);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    var initialPanes = [];
    var templateId = -1;

    getListTemplatesUser().then((res) => {
      res.forEach((element) => {
        initialPanes.push({
          title: element.name,
          content: element.name,
          indicators: element.indicators,
          key: element.id,
          visible: false,
          inputs: element.inputs,
          currency: element.currency,
          symbol: element.symbol,
          results: element.results,
        });
      });
      if (id != -1) {
        try {
          toGetDetailAssessment(id).then((res) => {
            if (!res) {
              navigate("/");
            } else {
              templateId = res.templateId;
              var index = initialPanes.findIndex((e) => e.key == templateId);
              if (index == -1) {
                index = 0;
              }
              initialPanes[index] = res;
              toActivateItem(index, initialPanes);

              setStep(3);
            }
          });
        } catch (error) {
          navigate("/");
        }
      } else {
        if (initialPanes.length > 0) {
          if (SettingStore.templateId)
            var index = initialPanes.findIndex(
              (e) => e.key == SettingStore.templateId
            );
          if (!index || index == -1) {
            index = 0;
          }
          toActivateItem(index, initialPanes);
        }
      }

      setTimeout(() => {
        setLoading(false);
      }, 500);
    });
  }, []);

  const toActivateItem = (index, initialPanes) => {
    const item = initialPanes[index];
    setSelectedItem(item);

    setTemplates(initialPanes);
    setElRefs((elRefs) =>
      Array(initialPanes.length)
        .fill()
        .map((_, i) => elRefs[i] || createRef())
    );
    setActive(item.key);
  };

  const OnChange = (activeKey) => {
    setSelectedItem(templates.find((i) => i.key == activeKey));
    setActive(activeKey);
  };

  const hidePopup = () => {
    var initialPanes = [...templates];
    if (targetKey != -1) {
      initialPanes.forEach((element) => {
        element.visible = false;
      });
      setTemplates(initialPanes);
      setTargetKey(-1);
    }
  };

  return (
    <div onClick={() => hidePopup()}>
      <HeaderUser step={step} updateStep={() => setStep(step - 1)} />
      {loading ? (
        <ScreenLoader />
      ) : (
        <>
          {templates.length > 0 ? (
            <>
              <div style={{ marginTop: "4vh" }}>
                <Row>
                  <Col span="16">
                    <span
                      className="roi--label-section"
                      style={{ marginLeft: "2vh" }}
                    >
                      <FormattedMessage id="fillTheform" />
                    </span>
                  </Col>
                  <Col span="7" style={{ float: "right" }}>
                    <Button
                      icon={<img src="/images/icons/folder.svg" />}
                      className="roi--button-open-saved"
                      onClick={() => navigate("/forms")}
                    >
                      <span style={{ marginLeft: "5px" }}>
                        <FormattedMessage id="openForm" />
                      </span>
                    </Button>
                  </Col>
                </Row>
              </div>
              <Tabs
                type="card"
                onChange={OnChange}
                hideAdd
                activeKey={activeKey + ""}
              >
                {templates.map((pane, index) => (
                  <TabPane
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    <div className="roi--tab">
                      <PracticeForm selected={selectedItem} showBtns={true} />
                    </div>
                  </TabPane>
                ))}
              </Tabs>
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "10vh" }}>
              <Typography.Title level={2} className="roi--title-admin">
                <FormattedMessage id="contactAdmin" />
              </Typography.Title>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NewTool;
